/** Returns a promise that resolves after the given milliseconds.
 * This is useful for emulating thread sleep in async functions.
 */
export const timeout = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
